// Static UI content for Files on Radar

export const features = [
  { icon: 'FileText', accent: 'blue', title: 'Structured Requests', description: 'Create detailed document requests with specific tasks and deadlines. No more vague email threads.' },
  { icon: 'ShieldCheck', accent: 'emerald', title: 'Secure & Compliant', description: 'Every file upload, status change, and comment is logged in a tamper-proof audit trail.' },
  { icon: 'Users', accent: 'violet', title: 'Clear Ownership', description: "Each request is assigned directly to a firm employee. You always know who's handling your work." },
];

export const steps = [
  { n: 1, title: 'Client creates request', description: "Describes what's needed and assigns a firm employee." },
  { n: 2, title: 'Employee uploads', description: 'Employee processes the request and uploads completed documents task by task.' },
  { n: 3, title: 'Employee submits', description: 'When ready, employee submits the documents for client review.' },
  { n: 4, title: 'Client reviews', description: 'Client accepts the documents (closed) or rejects with feedback.' },
];

export const plans = [
  {
    id: 'free', name: 'Starter', price: 0, unit: 'forever',
    tagline: 'Up to 5 clients & 10 requests per client',
    perks: ['Up to 5 clients', '10 document requests per client', 'Unlimited firm staff', 'Audit trail & email invites'],
    highlight: false, cta: 'Get started',
  },
  {
    id: 'monthly', name: 'Monthly', price: 499, unit: '/month',
    tagline: 'Unlimited requests, billed monthly',
    perks: ['Unlimited document requests', 'Priority processing', 'Full audit trail export', 'Coupon FIRSTTIME → 10% off'],
    highlight: true, cta: 'Choose Monthly',
  },
  {
    id: 'annual', name: 'Annual', price: 3600, unit: '/year', monthly: 300, save: 200,
    tagline: 'Best value — Rs.300/month',
    perks: ['Everything in Monthly', 'Save ~Rs.200 every month', '2 months free effectively', 'Dedicated support'],
    highlight: false, cta: 'Choose Annual',
  },
];

export const MOUNTAIN_BG = 'https://images.unsplash.com/photo-1552152370-fb05b25ff17d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxtaXN0eSUyMG1vdW50YWluc3xlbnwwfHx8fDE3ODYxODQyNjd8MA&ixlib=rb-4.1.0&q=85';

export const companyTypes = ['Private Ltd', 'Public Co', 'Firm LLP', 'Sole Proprietorship'];
